import { Form, Input, Modal, Skeleton } from "antd";
import { useEffect, useRef, useState } from "react";
import { formStyle, TitleIndex } from "../styles";

import { useError } from "../../../uteis/mensagens/useError";
import { useSuccess } from "../../../uteis/mensagens/useSuccess";
import { useNavigate } from "react-router-dom";
import { useAtualizarInfoPag } from "../Hooks/useAtualizarInfoPag";
import { useInfoPagamentoAtivo } from "../Hooks/useInfoPagamentoAtivo";

export default function ModalEditar({
  isModalOpen,
  handleFechar,
  usuarioId,
}: any) {
  const [formInfoPagamento] = Form.useForm();

  // Estado inicial de dos dados Lead que serão atualizados
  const [info, setInfo] = useState<any>({});

  const { infoPagData, isLoading: isLoadingInfoPagamento } =
    useInfoPagamentoAtivo(usuarioId);

  const { atualizar, isLoading, error, success } = useAtualizarInfoPag();
  // Função que armazena os dados alterados de Info Pagamento
  const infoChange = (changedValues: Partial<any>, allValues: any) => {
    setInfo({ ...allValues, id: usuarioId });
  };

  // Exibe a Mensagem de  Erro
  const { showError, contextHolder: errorContextHolder } = useError();

  // Exibe a Mensagem de  Sucesso
  const { showSuccess, contextHolder: successContextHolder } = useSuccess();

  // Estado para controlar se o erro já foi exibido
  const [errorDisplayed, setErrorDisplayed] = useState(false);

  // Estado para controlar se o sucesso já foi exibido
  const [successDisplayed, setSuccessDisplayed] = useState(false);

  // Hook de navegação do React Router
  const navigate = useNavigate();

  const errorRef = useRef<string | null>(null);

  useEffect(() => {
    if (isModalOpen) {
      formInfoPagamento.setFieldsValue({
        pix: infoPagData?.pix,
      });
    }
  }, [isModalOpen, infoPagData, formInfoPagamento]);

  useEffect(() => {
    if (error) {
      errorRef.current = error;
    }
  }, [error]);

  // useEffect para lidar com o sucesso
  useEffect(() => {
    if (success && !successDisplayed) {
      // Verifica se o sucesso já foi exibido
      showSuccess(success);
      setSuccessDisplayed(true);
      setTimeout(() => {
        navigate(0); // Use navigate(0) para simular um refresh completo
      }, 3000);
    }
    if (errorRef.current && !errorDisplayed) {
      // Verifica se o erro já foi exibido
      showError(errorRef.current);
      setErrorDisplayed(true); // Marca que o erro foi exibido

      // Limpa estado de error após 3 segundos
      setTimeout(() => {
        setErrorDisplayed(false);
        errorRef.current = null;
      }, 3000);
    }
  }, [
    success,
    showSuccess,
    successDisplayed,
    errorDisplayed,
    showError,
    navigate,
  ]);

  return (
    <>
      <Modal
        open={isModalOpen}
        onCancel={handleFechar}
        cancelText="Cancelar"
        okText="Atualizar"
        onOk={() => atualizar(info)}
        confirmLoading={isLoading}
        okButtonProps={{
          style: {
            backgroundColor: "#003644",
            borderColor: "#003644",
            color: "white",
          }, // Botão "Ativar" com fundo verde
        }}
        cancelButtonProps={{
          style: {
            backgroundColor: "#f44336",
            borderColor: "#f44336",
            color: "white",
          }, // Botão "Cancelar" com fundo vermelho
        }}
      >
        <>{errorContextHolder}</>
        <>{successContextHolder}</>
        {isLoadingInfoPagamento && <Skeleton active />}
        {!isLoadingInfoPagamento && infoPagData && (
          <>
            <TitleIndex>Insira a chave Pix</TitleIndex>
            <Form
              form={formInfoPagamento}
              onValuesChange={(changedValues, allValues) =>
                infoChange(changedValues, allValues)
              }
              name="Info-Pagamento"
              style={formStyle}
            >
              <Form.Item
                name={["pix"]}
                label="Chave Pix "
                className="formItems"
                rules={[{ required: true }]}
              >
                <Input />
              </Form.Item>
            </Form>
          </>
        )}
      </Modal>
    </>
  );
}
